import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { RouteType } from "../models/enum";
import { RoleService } from "../shared/services/role.service";
import { SESSION } from "src/session.config";
import { GoogleAuthService } from "./google-api.service";
import { isOfflineWorkRoute } from "./offline-work-route.utils";
import { setReturnUrl } from "./return-url.utils";

@Injectable({
	providedIn: "root",
})
export class InstructorService {
	constructor(
		private router: Router,
		private roleService: RoleService,
		private authService: GoogleAuthService,
	) {}

	async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		const hasCachedUser = !!localStorage.getItem(SESSION.SESSION_KEY_USER);

		if (!navigator.onLine && isOfflineWorkRoute(state.url) && hasCachedUser && this.roleService.hasInstructorView) {
			return true;
		}

		if (!navigator.onLine) {
			if (this.authService.hasValidOfflineSession() && this.roleService.hasInstructorView) {
				return true;
			}
			if (!this.authService.hasValidOfflineSession()) {
				this.redirectToLogin(state.url);
			} else {
				this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
			}
			return false;
		}

		const authenticated = await this.authService.ensureSessionResolved();
		if (authenticated && this.roleService.hasInstructorView) {
			return true;
		}

		if (!authenticated) {
			this.redirectToLogin(state.url);
		} else {
			this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
		}
		return false;
	}

	private redirectToLogin(returnUrl: string): void {
		setReturnUrl(returnUrl);
		this.router.navigate([RouteType.LOGIN], {
			queryParams: { returnUrl },
		});
	}
}
